<div class="sm:mx-auto sm:w-full sm:max-w-md flex flex-col items-center sticky">
  <img ngSrc="assets/logo.webp" alt="QuickDrive Logo" class="w-24" width="100" height="35" />

  <div class="sm:mx-auto sm:w-full sm:max-w-sm">
    <h2
      class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-gray-100"
    >
      Passwort vergessen
    </h2>
  </div>

  <form [formGroup]="emailForm" class="w-full p-4 rounded-lg form-container" (ngSubmit)="handleSubmit()">
    <div>
      <ion-input
        appAutofill
        #input
        label="Deine E-Mail"
        helperText="Bitte gib deine E-Mail Adresse ein."
        errorText="E-Mail Adresse ungültig"
        label-placement="floating"
        type="email"
        formControlName="email"
        id="email"
        placeholder="name@quickdrive.ch"
        required
      ></ion-input>
    </div>

    <ion-button
      type="submit"
      mode="ios"
      class="mb-4 mt-6"
      expand="block"
      [disabled]="loading()"
      ><ion-label class="flex items-center gap-4"> @if (loading()) {<ion-spinner></ion-spinner>} Passwort zurücksetzen</ion-label></ion-button
    >
  </form>

  <p class="mt-10 text-center text-sm text-gray-500">
    Zurück zum
    <a
      href=""
      class="font-semibold leading-6 text-quickdrive hover:text-blue-800"
      (click)="handleChange($event)"
      >Login</a
    >
  </p>
</div>
